// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".complete-profile{background-color:#e50a96;border:1px solid #f00c77}", ""]);
// Exports
module.exports = exports;
